import { Injectable } from "@angular/core";
import { CanMatch, Router, UrlTree } from "@angular/router";
import { ApplicationConfigService } from "./services/application-config.service";

/** Module-level guard for routes that any authenticated user can reach.
 *  Anonymous users get redirected to /home rather than wasting bandwidth
 *  on the lazy-loaded bundle. */
@Injectable({ providedIn: 'root' })
export class LoggedInGuard implements CanMatch {

  constructor(private router: Router, private config: ApplicationConfigService) {}

  canMatch(): boolean | UrlTree {
    return this.config.getAuthorities().length > 0
      ? true
      : this.router.createUrlTree(['/home']);
  }
}
